module.exports =
  products:
    base: '/v2/products'
    bulk: '/v2/products/bulk' # Bulk product get route
    sizes: '/v2/products/sizes'
    search: '/v2/products/search'
    full: '/v2/products/full'
    detail: '/v2/products/:identifier'
    availability: '/v2/products/:identifier/availability'
    tags: '/v2/products/:identifier/tags'
    items: '/v2/products/:identifier/items'
    eligibility: '/v2/products/:identifier/eligibility'
  categories:
    base: '/v2/categories'
    full: '/v2/categories/full'
    detail: '/v2/categories/:identifier'
  order:
    base: '/v2/order' # Start an order with a quote
    facility: '/v2/order/facility' # find out where the items of an order is going
    detail: '/v2/order/:orderId'
    design: '/v2/order/:orderId/design'
    cancelItem: '/v2/order/:orderId/cancelItem'
    changeAddress: '/v2/order/:orderId/changeAddress'
    changeWhitelabel: '/v2/order/:orderId/changeWhitelabel'
    changeName: '/v2/order/:orderId/changeName'
    changeShippingMethod: '/v2/order/:orderId/changeShippingMethod'
    changeDesign: '/v2/order/:orderId/changeDesign'
    reprint: '/v2/order/:orderId/reprint'
    status: '/v2/order/:orderId/status'
  reship:
    list: '/v2/reship'
    detail: '/v2/reship/:reshipId'
    request: '/v2/reship/:reshipId/request'
    cancel: '/v2/reship/:reshipId/cancel'
  quote:
    base: '/v2/quote' # Generate a quote
    bulk: '/v2/quote/bulk'
    token: '/v2/quote/:orderToken'
    route: '/v2/quote/facility/route'
  design:
    base: '/v2/design'
    bulk: '/v2/design/bulk' # Bulk designId get
    detail: '/v2/design/:designId'
    search: '/v2/design/search'
    note: '/v2/design/:designId/note'
    approval:
      order:
        revise: '/v2/design/:designId/approval/order/revise'
  status:
    log: '/internal/status/log'
    qc: '/internal/status/qc'
    externalLog: '/internal/status/externalLog'
    design: '/internal/status/design' # Design validation status update
    shippingWorkstation: '/internal/status/shippingWorkstation'
  customization:
    base: '/v2/customization' # Get available customizations
  webhook:
    dispute:
      base: '/v2/print/webhook/dispute'
    inboundEmail:
      base: '/v2/print/webhook/inboundEmail'
    dtg2go:
      base: '/v2/print/webhook/dtg2go'
  billing:
    balance: '/v2/billing/balance'
    invoice:
      base: '/v2/billing/invoice'
      detail: '/v2/billing/invoice/:invoiceId'
      pay:
        paypal: '/v2/billing/invoice/:invoiceId/pay/paypal'
  v3:
    shipping:
      base: '/v3/shipping'
      thirdPartyShip: '/v3/shipping/thirdPartyShip'
      option:
        base: '/v3/shipping/option'
    tracking: '/v3/tracking/:trackingNumber'
    address:
      validate: '/v3/address/validate'
      validateMWW: '/v3/address/validateMWW'
    event:
      base: '/v3/event'
      detail: '/v3/event/:eventId'
    order:
      base: '/v3/order' # Start an order with a quote
      facility: '/v3/order/facility' # find out where the items of an order is going
      detail: '/v3/order/:orderId'
      changeAddress: '/v3/order/:orderId/changeAddress'
      reprint: '/v3/order/:orderId/reprint'
      item:
        base: '/v3/order/:orderId/item/:itemIndex'
        event: '/v3/order/:orderId/item/:itemIndex/event'
      event:
        base: '/v3/order/:orderId/event'
      approval:
        base: '/v3/order/:orderId/approval'
      updateProcessedDesigns: '/v3/order/:orderId/updateProcessedDesigns',
    quote:
      base: '/v3/quote' # Generate a quote
      # bulk: '/v3/quote/bulk' Does not exist (only quote.base exist)
      token: '/v3/quote/:orderToken'
    mockup:
      base: '/v3/mockup'
      blank: '/v3/mockup/blank/:template/:color.png'
      clippingMask: '/v3/mockup/clippingMask/:template.png'
    mockupTemplate:
      base: '/v3/mockup-template'
      detail: '/v3/mockup-template/id/:mockupTemplateId'
      byIdentifier: '/v3/mockup-template/byIdentifier'
      bulkByIdentifier: '/v3/mockup-template/bulkByIdentifier'
    artwork: # Artwork API
      base: '/v3/artwork'
      search: '/v3/artwork/search'
      detail: '/v3/artwork/:artworkId'
      bulk: '/v3/artwork/bulk'
      rights: '/v3/artwork/:artworkId/rights'
      update:
        name: '/v3/artwork/:artworkId/update/name'
      delete: '/v3/artwork/:artworkId/delete'
      actions: '/v3/artwork/:artworkId/actions'
      design:
        case: '/v3/artwork/design/case'
        mug: '/v3/artwork/design/mug'
        screenprint: '/v3/artwork/design/screenprint'
        dtg: '/v3/artwork/design/dtg'
        poster: '/v3/artwork/design/poster'
        embr: '/v3/artwork/design/embr'
        sublimation: '/v3/artwork/design/sublimation'
      printability:
        base: '/v3/artwork/printability',
        detail: '/v3/artwork/printability/:printabilityId',
        bulk: '/v3/artwork/printability/bulk'
      conversion:
        base: '/v3/artwork/conversion',
        detail: '/v3/artwork/conversion/:conversionId',
        bulk: '/v3/artwork/conversion/bulk'
        embr: '/v3/artwork/:artworkId/conversion/embr'
    products:
      detail: '/v3/products/:identifier'
      filters: '/v3/products/filters'
      search: '/v3/products/search'
      rushQuantity: '/v3/products/rushQuantity'
    categories:
      base: '/v3/categories'
      detail: '/v3/categories/:identifier'
    design:
      base: '/v3/design'
      detail: '/v3/design/:designId'
    invoice:
      base: '/v3/invoice'
      detail: '/v3/invoice/:invoiceId'
    billing:
      balance: '/v3/billing/balance'
    customization:
      base: '/v3/customization'
    printable:
      base: '/v3/printable'
      detail: '/v3/printable/detail/:printableId'
      bulk: '/v3/printable/bulk'
    vendors:
      base: '/v3/vendors/:partner'
      detail: '/v3/vendors/:partner/:identifier'
    screenprint3pf: # deprecated
      vendor: '/v3/screenprint3pf/vendors/:identifier'
      vendors: '/v3/screenprint3pf/vendors'

  proxy:
    artwork:
      data:
        colors:
          base: '/proxy/artwork/data/colors'
        image:
          base: '/proxy/artwork/data/image'


    infringement:
      detect:
        base: '/proxy/infringement/detect'
  health:
    base: '/internal/__health'
    metrics: '/internal/__health/metrics/'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/print.coffee